"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
const lodash_1 = __importDefault(require("lodash"));
const prop_types_1 = require("prop-types");
const react_1 = __importStar(require("react"));
const colors_1 = require("../../utilities/colors");
const constants_1 = require("../../utilities/constants");
function LabelContainer(_ref) {
  let {
    labels = [],
    onClick = () => {},
    onMouseOver = () => {},
    onMouseOut = () => {},
    formatter = staticValue => staticValue
  } = _ref;
  const getDefaultValue = (propType, defaultValue, i) => {
    // useTransitions cannot animate a null or undefined value
    const currentValue = labels[i].style ? labels[i].style[propType] : null;
    return !lodash_1.default.isNil(currentValue) ? currentValue : defaultValue;
  };
  const propsToAnimate = labels.map((label, i) => {
    const color = label.style ? colors_1.COLOR_PALETTE[label.style.fill] || label.style.fill || colors_1.DEFAULT_COLORS[0] : colors_1.DEFAULT_COLORS[0];
    const opacity = getDefaultValue('opacity', 1, i);
    const fontSize = getDefaultValue('fontSize', constants_1.DEFAULT_FONT_SIZE, i);
    const fontWeight = getDefaultValue('fontWeight', 100, i);
    const letterSpacing = getDefaultValue('letterSpacing', 0, i);
    return {
      ...label,
      key: label.key || i,
      x: label.x || 0,
      y: label.y || 0,
      opacity,
      fontSize,
      fill: color,
      fontWeight,
      letterSpacing,
      forceRedraw: lodash_1.default.uniqueId()
    };
  });
  const styles = (0, react_1.useRef)(labels.map(_ref2 => {
    let {
      style
    } = _ref2;
    return style;
  }));
  return react_1.default.createElement("g", {
    className: "labels"
  }, propsToAnimate.map((label, i) => {
    const {
      key,
      x,
      y,
      fontSize,
      fill,
      fontWeight,
      letterSpacing,
      opacity,
      content
    } = label;
    if (key !== 0 && !key) {
      return null;
    }
    return react_1.default.createElement("text", {
      key: key,
      textAnchor: "start",
      x: x,
      y: y,
      style: {
        ...styles.current[i],
        opacity,
        fontSize,
        fill,
        fontWeight,
        letterSpacing
      },
      onMouseOver: event => onMouseOver(event, i),
      onMouseOut: event => onMouseOut(event, i),
      onClick: event => onClick(event, i)
    }, labels[i] && formatter(content, labels[i].key));
  }));
}
LabelContainer.propTypes = {
  /**
   * Array of labels. Each requires a content string at minimum.
   * Optional parameters: x: x position in pixels. y: y position in pixels.
   * key: key used for animations. style: stlying for the label.
   * (Numeric props will animate automatically)
   * onClick: Function to execute when clicked. onMouseOver: Function to execute when hovered over.
   */
  labels: (0, prop_types_1.arrayOf)((0, prop_types_1.shape)({
    content: prop_types_1.node,
    x: prop_types_1.number,
    y: prop_types_1.number,
    key: (0, prop_types_1.oneOfType)([prop_types_1.string, prop_types_1.number]),
    style: (0, prop_types_1.shape)()
  })).isRequired,
  /**
   * function to activate on click
   * parameters: (event, index)
   */
  onClick: prop_types_1.func,
  /**
   * function to activate on mouseOver
   * parameters: (event, index)
   */
  onMouseOver: prop_types_1.func,
  /**
   * function to activate on mouseOut
   * parameters: (event, index)
   */
  onMouseOut: prop_types_1.func,
  /**
   * custom formatter for animated values
   * parameters: (animatedValue, staticValue, key)
   */
  formatter: prop_types_1.func
};
exports.default = LabelContainer;